<ion-app class="exam">
  <dojo-app-loader />

  @if (!state.showFullScreenLoader) {
    @if (state.showLoadingBar) {
      <div class="bg-neutral-0 fixed left-0 top-0 z-[1000000] w-full" @appearDisappearWithHeight>
        <mat-progress-bar class="w-full" mode="indeterminate" />
      </div>
    }

    <dojo-informative-banner />
  }

  <router-outlet />

  <dojo-debugging-window *ngIfFeatureFlag="ExamDojoFeatureFlag.Testing">
    <ng-container actions>
      @if (state.gradedAttemptId) {
        <button (click)="openDatasetUploadDialog(state.gradedAttemptId)">
          <dojo-icon icon="flask" matTooltip="Upload dataset row" [matTooltipShowDelay]="1500"></dojo-icon>
        </button>
      }
    </ng-container>
  </dojo-debugging-window>
</ion-app>
